import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import DeliveriesComponent from '@app/components/ManageDeliveries/list';

const ManageDeliveries: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>Manage Deliveries</PageTitle>
      <DeliveriesComponent />
    </>
  );
};

export default ManageDeliveries;
